import { HttpClient } from '../http-client';
import { MembersResponse } from './types';

export class MemberHttpClient extends HttpClient {
  public async getAllMembers(): Promise<MembersResponse> {
    return this.get('/members');
  }
}
